export function debounce(ms: number, fn: () => void): () => void {
  let timeout: ReturnType<typeof setTimeout> | undefined
  return () => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(fn, ms)
  }
}

export function identity<T>(input: T): T {
  return input
}
